(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["molo-specifications"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('molo-specifications')) {
  customElements.define('molo-specifications', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
    }
    initialize() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.panels = [...this.querySelectorAll('[data-spec-panel]')];
      const tablist = this.querySelector('[data-spec-tabs]');
      if (!tablist || !this.panels.length) return;
      tablist.replaceChildren();
      this.tabs = this.panels.map((panel, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.id = `${panel.id}-tab`;
        tab.textContent = panel.dataset.specTitle;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', () => this.activate(index), options);
        tab.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          this.activate(next);
          this.tabs[next].focus({ preventScroll: true });
          this.revealTab(tablist, this.tabs[next]);
        }, options);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tablist.append(tab);
        return tab;
      });
      tablist.hidden = false;
      this.dataset.ready = '';
      this.activate(0);
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-spec-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) {
          this.activate(index);
          this.revealTab(tablist, this.tabs[index]);
        }
      }, options);
    }
    revealTab(list, tab) {
      const target = tab.getBoundingClientRect();
      const bounds = list.getBoundingClientRect();
      if (target.left < bounds.left) list.scrollLeft -= bounds.left - target.left;
      if (target.right > bounds.right) list.scrollLeft += target.right - bounds.right;
    }
    activate(index) {
      this.tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].hidden = !active;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-models"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-models')) {
    customElements.define('scroll-models', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.panels = Array.from(this.querySelectorAll('[data-sm-panel]'));
        if (!this.panels.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.stage = this.querySelector('.sm-stage');
        this.scene = this.querySelector('.sm-scene');
        this.viewportProbe = document.createElement('span');
        this.viewportProbe.className = 'sm-viewport-probe';
        this.viewportProbe.setAttribute('aria-hidden', 'true');
        this.append(this.viewportProbe);
        this.track = this.querySelector('.sm-track');
        this.navigation = this.querySelector('.sm-navigation');
        this.scrollHint = this.querySelector('.sm-scroll-hint');
        this.details = this.querySelector('[data-sm-details]');
        this.counter = this.querySelector('[data-sm-current]');
        this.progressMarkers = Array.from(this.querySelectorAll('[data-sm-marker]'));
        this.buttons = Array.from(this.querySelectorAll('[data-sm-go]'));
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.models = this.panels.map(panel => ({
          name: panel.querySelector('.sm-model-title').textContent.trim(),
          imageScale: parseFloat(panel.style.getPropertyValue('--sm-image-scale')) || 1,
          speed: panel.querySelector('[data-sm-speed]')?.textContent.trim() || '',
          range: panel.querySelector('[data-sm-range]')?.textContent.trim() || '',
          feature: panel.querySelector('.sm-feature')?.textContent.trim() || '',
          note: panel.querySelector('.sm-note')?.textContent.trim() || '',
          link: panel.querySelector('.sm-copy')?.getAttribute('href') || '',
          background: panel.dataset.background,
          textBackground: panel.dataset.textBackground,
          color: panel.dataset.textColor
        }));
        this.statNodes = ['speed', 'range'].map(key => {
          const row = this.details.querySelector(`[data-sm-stat="${key}"]`);
          return { key, row, number: row.querySelector('[data-sm-number]'), unit: row.querySelector('[data-sm-unit]'), target: row.querySelector('[data-sm-target]'), value: null };
        });
        this.rides = this.panels.map((panel, index) => {
          const kind = panel.dataset.rideMotion;
          const element = panel.querySelector('.sm-ride');
          if (!element || !['enter', 'exit'].includes(kind) || (kind === 'enter' && index !== 0)) return null;
          return { panel, index, kind, element, phase: 'shown', armed: false, frame: null, token: 0 };
        }).filter(Boolean);
        this.lastScrollY = window.scrollY;
        this.pendingScrollDirection = 0;
        this.ridesMeasured = false;
        this.activeIndex = -1;
        this.visible = true;
        this.onScroll = () => {
          const scrollY = window.scrollY;
          const change = scrollY - this.lastScrollY;
          this.lastScrollY = scrollY;
          if (Math.abs(change) > .5) this.pendingScrollDirection = change > 0 ? 1 : -1;
          if (this.enhanced && this.visible) this.scheduleRender();
        };
        // Mobile browser chrome changes viewport height during a swipe. The
        // small viewport probe stays stable, so those events must not reset rides.
        this.onResize = () => {
          const stableHeight = this.viewportProbe.getBoundingClientRect().height;
          if (!this.mobile || this.lastWidth !== this.clientWidth || Math.abs(stableHeight - this.lastViewportHeight) > 1) this.scheduleMeasure();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true, signal });
        window.addEventListener('resize', this.onResize, { passive: true, signal });
        this.motionQuery.addEventListener('change', () => this.scheduleMeasure(), { signal });
        this.buttons.forEach(button => button.addEventListener('click', event => {
          if (button.hasAttribute('data-sm-destination')) return;
          event.preventDefault();
          this.goTo(Number(button.dataset.smGo));
        }, { signal }));
        this.navigation.addEventListener('keydown', event => {
          if (!this.enhanced || !['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          const button = event.target.closest('[data-sm-go]');
          if (!button) return;
          const current = Number(button.dataset.smGo);
          const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : Math.max(0, Math.min(this.buttons.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
          event.preventDefault();
          this.goTo(target);
          this.buttons[target].focus({ preventScroll: true });
        }, { signal });
        document.addEventListener('click', event => {
          const link = event.target.closest?.('a[href]');
          if (!link) return;
          let destination;
          try { destination = new URL(link.href, window.location.href); } catch { return; }
          const samePage = destination.origin === window.location.origin && destination.pathname === window.location.pathname;
          const targetsRide = destination.hash === `#${this.id}` || this.panels.some(panel => destination.hash === `#${panel.id}`);
          if (samePage && targetsRide) this.showRidesWithoutAnimation();
        }, { capture: true, signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) requestAnimationFrame(() => { if (this.isConnected) this.goTo(index); });
        }, { signal });
        document.addEventListener('shopify:section:unload', event => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.disconnectedCallback();
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.lastWidth !== this.clientWidth) this.scheduleMeasure();
        });
        this.resizeObserver.observe(this);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.scheduleRender();
        }, { rootMargin: '150px' });
        this.intersectionObserver.observe(this);
        this.visibleStatGroups = new Set();
        this.statVisibilityObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const copy = entry.target.closest('.sm-copy');
            const entering = entry.isIntersecting && entry.intersectionRatio >= .1;
            const wasVisible = this.visibleStatGroups.has(entry.target);
            if (!entering) {
              this.visibleStatGroups.delete(entry.target);
              copy.classList.remove('is-divider-revealing');
              return;
            }
            this.visibleStatGroups.add(entry.target);
            if (!wasVisible && !this.enhanced && this.pendingScrollDirection > 0) this.revealDividers(copy);
          });
        }, { threshold: .1, rootMargin: '0px 0px -12% 0px' });
        this.querySelectorAll('.sm-copy .sm-stats').forEach(stats => this.statVisibilityObserver.observe(stats));
        document.fonts?.ready.then(() => { if (this.isConnected && this.controller) this.scheduleMeasure(); });
        this.measure();
        const linkedIndex = this.panels.findIndex(panel => `#${panel.id}` === window.location.hash);
        if (linkedIndex >= 0) requestAnimationFrame(() => { if (this.controller) this.goTo(linkedIndex); });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.viewportProbe?.remove();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.statVisibilityObserver?.disconnect();
        this.visibleStatGroups?.clear();
        cancelAnimationFrame(this.renderFrame);
        cancelAnimationFrame(this.measureFrame);
        cancelAnimationFrame(this.countFrame);
        this.renderFrame = null;
        this.measureFrame = null;
        this.countFrame = null;
        this.rides?.forEach(ride => this.cancelRide(ride, 0));
      }

      scheduleMeasure() {
        if (this.measureFrame) return;
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = null; this.measure(); });
      }

      measure() {
        if (!this.controller) return;
        this.querySelectorAll('.is-divider-revealing').forEach(element => element.classList.remove('is-divider-revealing'));
        this.lastWidth = this.clientWidth;
        const header = document.querySelector('.site-header');
        const headerStyle = header ? getComputedStyle(header) : null;
        const overlays = header && (headerStyle.position === 'fixed' || (headerStyle.position === 'sticky' && header.parentElement.contains(this)));
        this.stickyTop = overlays ? Math.ceil(header.getBoundingClientRect().height) : 0;
        this.mobile = window.matchMedia('(max-width: 900px)').matches;
        this.lastViewportHeight = this.viewportProbe.getBoundingClientRect().height;
        const viewportHeight = this.mobile ? Math.min(document.documentElement.clientHeight, this.lastViewportHeight) : document.documentElement.clientHeight;
        this.stageHeight = Math.max(1, viewportHeight - this.stickyTop);
        this.readTravel = 0;
        this.style.setProperty('--sm-content-pan', '0px');
        this.vehicleHeight = Math.min(300, Math.round(this.stageHeight * .34));
        if (this.mobile) {
          const baseVehicleHeight = Math.max(this.vehicleHeight, 108);
          const imageWidth = Math.min(window.innerWidth * .684, baseVehicleHeight * 1.032, 468);
          const largestScale = Math.max(...this.panels.map(panel => parseFloat(panel.style.getPropertyValue('--sm-image-scale')) || 1));
          this.style.setProperty('--sm-mobile-base-height', `${baseVehicleHeight}px`);
          this.vehicleHeight = Math.ceil(imageWidth * 1.05 * largestScale) + 8;
        }
        this.step = this.mobile ? this.vehicleHeight : this.stageHeight;
        this.style.setProperty('--sm-sticky-top', `${this.stickyTop}px`);
        this.style.setProperty('--sm-stage-height', `${this.stageHeight}px`);
        this.style.setProperty('--sm-vehicle-height', `${this.vehicleHeight}px`);
        this.style.setProperty('--sm-step', `${this.step}px`);
        this.lastCenter = this.step * (this.panels.length - 1);
        this.endDistance = this.lastCenter;
        this.exitRide = this.rides.find(ride => ride.kind === 'exit' && ride.index === this.panels.length - 1);
        this.style.setProperty('--sm-track-height', `${this.stageHeight + this.lastCenter}px`);
        cancelAnimationFrame(this.countFrame);
        this.countFrame = null;
        let enhance = (this.panels.length > 1 || this.rides.length > 0) && !this.motionQuery.matches && this.clientWidth >= 320;
        if (enhance) {
          this.classList.add('is-enhanced');
          this.details.hidden = false;
          let largestDetails = 0;
          this.models.forEach((model, index) => {
            this.populateDetails(index, false);
            largestDetails = Math.max(largestDetails, this.details.scrollHeight);
          });
          const navigationHeight = this.navigation.getBoundingClientRect().height;
          const hintHeight = this.scrollHint?.offsetHeight || 0;
          const hintBottom = this.scrollHint ? parseFloat(getComputedStyle(this.scrollHint).bottom) || 0 : 0;
          const hintClearance = hintHeight * (this.mobile ? 1.3 : 1) + hintBottom + 18;
          if (this.mobile) {
            // Give each model its own reading distance on short screens. Never
            // turn off all motion just because a configuration note is taller.
            this.style.setProperty('--sm-hint-clearance', `${hintClearance}px`);
            const availableHeight = Math.max(1, this.stageHeight - 48 - hintClearance);
            this.style.setProperty('--sm-scene-height', `${availableHeight}px`);
            this.readTravel = Math.max(0, Math.ceil(this.details.offsetTop + largestDetails - availableHeight));
            this.step = this.vehicleHeight + this.readTravel;
            this.lastCenter = this.step * (this.panels.length - 1);
            this.endDistance = this.lastCenter + this.readTravel;
            this.style.setProperty('--sm-step', `${this.step}px`);
            this.style.setProperty('--sm-track-height', `${this.stageHeight + this.endDistance}px`);
          } else {
            const requiredHeight = Math.max(navigationHeight, largestDetails) + hintClearance * 2;
            enhance = this.stageHeight >= requiredHeight;
          }
        }
        this.progressMarkers.forEach((marker, index) => {
          const progress = this.endDistance > 0 ? index * this.step / this.endDistance : 0;
          const top = Math.max(8, Math.min(this.stageHeight - 8, progress * this.stageHeight));
          marker.style.setProperty('--sm-marker-position', `${top}px`);
        });
        this.enhanced = enhance;
        this.classList.toggle('is-enhanced', enhance);
        this.details.hidden = !enhance;
        this.activeIndex = -1;
        this.measureRides();
        this.lastScrollY = window.scrollY;
        this.pendingScrollDirection = 0;
        this.lastRawDistance = this.stickyTop - this.getBoundingClientRect().top;
        if (enhance) {
          this.render(false);
        } else {
          this.track.style.removeProperty('transform');
          this.panels.forEach(panel => {
            panel.inert = false;
            panel.removeAttribute('aria-hidden');
            panel.removeAttribute('data-current');
          });
          this.buttons.forEach(button => {
            button.removeAttribute('aria-current');
            button.removeAttribute('tabindex');
            button.style.removeProperty('--sm-roll-angle');
            button.style.removeProperty('--sm-roll-depth');
          });
          this.style.setProperty('--sm-background', this.models[0].background);
          this.style.setProperty('--sm-text-background', this.models[0].textBackground);
          this.style.setProperty('--sm-text', this.models[0].color);
        }
      }

      scheduleRender() {
        if (this.renderFrame) return;
        this.renderFrame = requestAnimationFrame(() => {
          this.renderFrame = null;
          if (this.enhanced) this.render();
        });
      }

      scrollState(rawDistance) {
        const distance = Math.max(0, Math.min(this.endDistance, rawDistance));
        if (!this.mobile) return { distance, position: distance / this.step, pan: 0 };
        const index = Math.min(this.models.length - 1, Math.floor(distance / this.step));
        const local = distance - index * this.step;
        const transition = index < this.models.length - 1 ? Math.max(0, (local - this.readTravel) / this.vehicleHeight) : 0;
        return {
          distance,
          position: index + transition,
          pan: transition > 0 ? this.readTravel * (1 - transition) : Math.min(local, this.readTravel)
        };
      }

      render(animate = true) {
        const rawDistance = this.stickyTop - this.getBoundingClientRect().top;
        const { distance, position, pan } = this.scrollState(rawDistance);
        this.style.setProperty('--sm-progress', this.endDistance > 0 ? String(distance / this.endDistance) : '1');
        this.style.setProperty('--sm-model-position', String(Math.min(position, Math.max(0, this.models.length - 2))));
        this.style.setProperty('--sm-roll-position', String(position));
        this.buttons.forEach((button, index) => {
          const offset = Math.max(-1.5, Math.min(1.5, index - position));
          button.style.setProperty('--sm-roll-angle', `${(-offset * 40).toFixed(3)}deg`);
          button.style.setProperty('--sm-roll-depth', `${(-Math.abs(offset) * 12).toFixed(3)}px`);
        });
        this.style.setProperty('--sm-content-pan', `${pan}px`);
        const current = Math.round(position);
        if (!this.mobile) this.style.setProperty('--sm-active-image-scale', String(this.models[current].imageScale));
        const direction = animate ? this.pendingScrollDirection : 0;
        this.pendingScrollDirection = 0;
        this.updateRides(rawDistance, direction, current);
        this.lastRawDistance = rawDistance;
        this.track.style.transform = `translate3d(0,${-position * this.step}px,0)`;
        this.renderBackground(position);
        if (direction < 0) this.details.classList.remove('is-divider-revealing');
        if (current === this.activeIndex) return;
        const revealDivider = animate && direction > 0 && this.activeIndex >= 0 && current > this.activeIndex;
        this.details.classList.remove('is-divider-revealing');
        this.activeIndex = current;
        this.progressMarkers.forEach((marker, index) => marker.toggleAttribute('data-current', index === current));
        const focusInPanel = this.panels.some(panel => panel.contains(document.activeElement));
        this.panels.forEach((panel, index) => {
          panel.inert = index !== current;
          panel.setAttribute('aria-hidden', String(index !== current));
          panel.toggleAttribute('data-current', index === current);
        });
        const focusInNavigation = this.buttons.includes(document.activeElement);
        this.buttons.forEach((button, index) => {
          button.tabIndex = index === current ? 0 : -1;
          if (index === current) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        if (focusInNavigation || focusInPanel) this.buttons[current]?.focus({ preventScroll: true });
        this.populateDetails(current, animate);
        if (revealDivider) this.revealDividers(this.details);
        if (this.counter) this.counter.textContent = String(current + 1).padStart(2, '0');
      }

      measureRides() {
        const rawDistance = this.stickyTop - this.getBoundingClientRect().top;
        const stageBounds = this.stage.getBoundingClientRect();
        this.rides.forEach(ride => {
          const wasArmed = ride.armed && ride.phase === 'armed';
          const wasLoading = ride.kind === 'enter' && ride.phase === 'loading';
          this.cancelRide(ride, 0);
          const vehicle = ride.panel.querySelector('.sm-vehicle') || ride.element;
          const bounds = vehicle.getBoundingClientRect();
          ride.fromLeft = -bounds.right - 16;
          ride.toRight = stageBounds.right - bounds.left + 16;
          const radius = Number(ride.element.dataset.wheelRadius || ride.panel.dataset.wheelRadius || 140);
          ride.radius = Math.max(1, bounds.width * radius / 1254);
          ride.center = ride.index * this.step;
          ride.threshold = ride.kind === 'enter'
            ? ride.center - (ride.index === 0 ? this.stageHeight * .12 : this.step * .22)
            : this.endDistance + 1;
          const canArm = this.enhanced && ride.kind === 'enter' && rawDistance < ride.threshold;
          ride.armed = canArm && (!this.ridesMeasured || wasArmed || wasLoading);
          ride.phase = ride.armed ? 'armed' : 'shown';
          if (wasLoading && this.enhanced && this.entryIsCurrent(ride)) {
            ride.armed = false;
            this.playRide(ride, ride.fromLeft, 0, 500);
          }
          if (ride.kind === 'exit') ride.armed = this.enhanced && rawDistance <= ride.threshold;
        });
        this.ridesMeasured = true;
      }

      setRidePosition(ride, x, angle = 0) {
        ride.element.style.transform = x ? `translate3d(${x.toFixed(3)}px,0,0)` : '';
        ride.element.style.setProperty('--sm-wheel-angle', `${angle.toFixed(3)}deg`);
      }

      entryIsCurrent(ride) {
        const rawDistance = this.stickyTop - this.getBoundingClientRect().top;
        const { position } = this.scrollState(rawDistance);
        return this.pendingScrollDirection >= 0 && rawDistance >= ride.threshold && Math.round(position) === ride.index && this.stage.getBoundingClientRect().bottom > this.stickyTop;
      }

      cancelRide(ride, x = 0) {
        cancelAnimationFrame(ride.frame);
        ride.frame = null;
        ride.token += 1;
        ride.element.removeAttribute('data-ride-moving');
        this.setRidePosition(ride, x);
      }

      updateRides(rawDistance, direction, current) {
        this.rides.forEach(ride => {
          if (ride.kind === 'enter') {
            if (direction < 0 && ['loading', 'running'].includes(ride.phase)) {
              this.cancelRide(ride, 0);
              ride.phase = 'shown';
              ride.armed = false;
            }
            const vehicle = ride.panel.querySelector('.sm-vehicle') || ride.element;
            if (direction < 0 && rawDistance < ride.threshold && vehicle.getBoundingClientRect().top >= document.documentElement.clientHeight) {
              this.cancelRide(ride, 0);
              ride.phase = 'armed';
              ride.armed = true;
            }
            if (direction > 0 && ride.armed && rawDistance >= ride.threshold) {
              ride.armed = false;
              if (current === ride.index && this.lastRawDistance < ride.threshold) {
                this.playRide(ride, ride.fromLeft, 0, 500);
              } else {
                this.cancelRide(ride, 0);
                ride.phase = 'shown';
              }
            }
            if (['loading', 'running'].includes(ride.phase) && current !== ride.index) {
              this.cancelRide(ride, 0);
              ride.phase = 'shown';
            }
            return;
          }
          if (ride !== this.exitRide) return;
          if (direction < 0 || rawDistance <= ride.threshold) {
            if (ride.phase !== 'shown') this.cancelRide(ride, 0);
            ride.phase = 'shown';
            ride.armed = rawDistance <= ride.threshold;
            return;
          }
          if (direction > 0 && ride.armed && this.lastRawDistance <= ride.threshold && rawDistance > ride.threshold) {
            ride.armed = false;
            if (rawDistance <= ride.threshold + this.stageHeight) {
              this.playRide(ride, 0, ride.toRight, 500);
            } else {
              this.cancelRide(ride, ride.toRight);
              ride.phase = 'exited';
            }
          }
        });
      }

      playRide(ride, from, to, duration) {
        this.cancelRide(ride, ride.kind === 'enter' ? 0 : from);
        const token = ride.token;
        ride.phase = 'loading';
        const image = ride.panel.querySelector('.sm-image');
        const begin = () => {
          if (token !== ride.token || !this.controller || !this.enhanced || this.motionQuery.matches) return;
          if (ride.kind === 'enter' && !this.entryIsCurrent(ride)) {
            this.cancelRide(ride, 0);
            ride.phase = 'shown';
            return;
          }
          const source = image?.currentSrc || image?.src;
          if (source) ride.panel.querySelectorAll('[data-sm-wheel-source]').forEach(node => node.setAttribute('href', source));
          ride.phase = 'running';
          ride.element.setAttribute('data-ride-moving', '');
          const started = performance.now();
          const move = now => {
            if (token !== ride.token || !this.controller || !this.enhanced) return;
            const progress = Math.max(0, Math.min(1, (now - started) / duration));
            const eased = ride.kind === 'enter' ? 1 - (1 - progress) ** 3 : progress * progress;
            const x = from + (to - from) * eased;
            const angle = (x - from) / ride.radius * 180 / Math.PI;
            this.setRidePosition(ride, x, angle);
            if (progress < 1) {
              ride.frame = requestAnimationFrame(move);
            } else {
              ride.frame = null;
              ride.phase = ride.kind === 'enter' ? 'shown' : 'exited';
              ride.element.removeAttribute('data-ride-moving');
            }
          };
          ride.frame = requestAnimationFrame(move);
        };
        const failed = () => {
          if (token !== ride.token) return;
          this.cancelRide(ride, 0);
          ride.phase = 'shown';
        };
        if (image?.decode && ride.kind === 'enter') {
          image.decode().then(begin).catch(failed);
        } else if (!image || (image.complete && image.naturalWidth > 0)) {
          begin();
        } else if (image.decode) {
          image.decode().then(begin).catch(failed);
        } else {
          image.addEventListener('load', begin, { once: true, signal: this.controller.signal });
          image.addEventListener('error', failed, { once: true, signal: this.controller.signal });
        }
      }

      showRidesWithoutAnimation() {
        this.rides.forEach(ride => {
          this.cancelRide(ride, 0);
          ride.phase = 'shown';
          ride.armed = false;
        });
        this.pendingScrollDirection = 0;
      }

      renderBackground(position) {
        const from = this.models[Math.floor(position)];
        const to = this.models[Math.min(this.models.length - 1, Math.floor(position) + 1)];
        const progress = Math.max(0, Math.min(1, ((position % 1) - .2) / .6));
        const eased = progress * progress * (3 - 2 * progress);
        const mix = key => {
          const first = this.colorChannels(from[key]);
          const second = this.colorChannels(to[key]);
          return first.map((value, index) => Math.round(value + (second[index] - value) * eased));
        };
        const background = mix('background');
        const textBackground = mix('textBackground');
        this.style.setProperty('--sm-background', `rgb(${background.join(',')})`);
        this.style.setProperty('--sm-text-background', `rgb(${textBackground.join(',')})`);
        const light = this.luminance(textBackground);
        const contrast = color => {
          const textLight = this.luminance(this.colorChannels(color));
          return (Math.max(light, textLight) + .05) / (Math.min(light, textLight) + .05);
        };
        const color = progress === 0 ? from.color : progress === 1 ? to.color : contrast(from.color) >= contrast(to.color) ? from.color : to.color;
        this.style.setProperty('--sm-text', color);
      }

      colorChannels(hex) {
        let value = hex.replace('#', '');
        if (value.length === 3) value = value.split('').map(part => part + part).join('');
        return [0, 2, 4].map(index => parseInt(value.slice(index, index + 2), 16));
      }

      luminance(channels) {
        const linear = channels.map(channel => {
          const value = channel / 255;
          return value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4;
        });
        return linear[0] * .2126 + linear[1] * .7152 + linear[2] * .0722;
      }

      revealDividers(container) {
        container.classList.remove('is-divider-revealing');
        if (this.motionQuery.matches) return;
        void container.offsetWidth;
        container.classList.add('is-divider-revealing');
      }

      populateDetails(index, animate) {
        const model = this.models[index];
        this.details.querySelector('[data-sm-name]').textContent = model.name;
        const feature = this.details.querySelector('[data-sm-feature]');
        const note = this.details.querySelector('[data-sm-note]');
        const link = this.details;
        feature.textContent = model.feature;
        feature.hidden = !model.feature;
        note.textContent = model.note;
        note.hidden = !model.note;
        if (!model.link && link.contains(document.activeElement)) this.buttons[index]?.focus({ preventScroll: true });
        if (model.link) link.setAttribute('href', model.link);
        else link.removeAttribute('href');
        cancelAnimationFrame(this.countFrame);
        this.countFrame = null;
        const transitions = [];
        this.statNodes.forEach(stat => {
          const text = model[stat.key];
          const match = text.match(/^\s*(\d+(?:\.\d+)?)\s*(.*)$/);
          stat.row.hidden = !text;
          stat.target.textContent = text;
          if (!match) {
            stat.number.textContent = text;
            stat.unit.textContent = '';
            stat.value = null;
            return;
          }
          const target = Number(match[1]);
          const decimals = (match[1].split('.')[1] || '').length;
          const from = stat.value;
          stat.unit.textContent = match[2];
          if (animate && from !== null && from !== target && !this.motionQuery.matches) {
            transitions.push({ stat, from, target, decimals });
          } else {
            stat.value = target;
            stat.number.textContent = target.toFixed(decimals);
          }
        });
        if (!transitions.length) return;
        const started = performance.now();
        const count = now => {
          if (!this.controller || !this.enhanced) return;
          const progress = Math.min(1, (now - started) / 380);
          const eased = 1 - Math.pow(1 - progress, 3);
          transitions.forEach(({ stat, from, target, decimals }) => {
            stat.value = from + (target - from) * eased;
            stat.number.textContent = stat.value.toFixed(decimals);
          });
          this.countFrame = progress < 1 ? requestAnimationFrame(count) : null;
        };
        this.countFrame = requestAnimationFrame(count);
      }

      goTo(index) {
        if (!this.panels[index]) return;
        this.showRidesWithoutAnimation();
        if (this.enhanced) {
          const sectionTop = this.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: Math.max(0, sectionTop - this.stickyTop + this.step * index), behavior: 'instant' });
          this.lastScrollY = window.scrollY;
          this.lastRawDistance = this.stickyTop - this.getBoundingClientRect().top;
          this.activeIndex = -1;
          this.render(false);
        } else {
          this.panels[index].scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys26-specifications"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('molo-specifications')) {
  customElements.define('molo-specifications', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
    }
    initialize() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.panels = [...this.querySelectorAll('[data-spec-panel]')];
      const tablist = this.querySelector('[data-spec-tabs]');
      if (!tablist || !this.panels.length) return;
      tablist.replaceChildren();
      this.tabs = this.panels.map((panel, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.id = `${panel.id}-tab`;
        tab.textContent = panel.dataset.specTitle;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', () => this.activate(index), options);
        tab.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          this.activate(next);
          this.tabs[next].focus({ preventScroll: true });
          this.revealTab(tablist, this.tabs[next]);
        }, options);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tablist.append(tab);
        return tab;
      });
      tablist.hidden = false;
      this.dataset.ready = '';
      this.activate(0);
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-spec-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) {
          this.activate(index);
          this.revealTab(tablist, this.tabs[index]);
        }
      }, options);
    }
    revealTab(list, tab) {
      const target = tab.getBoundingClientRect();
      const bounds = list.getBoundingClientRect();
      if (target.left < bounds.left) list.scrollLeft -= bounds.left - target.left;
      if (target.right > bounds.right) list.scrollLeft += target.right - bounds.right;
    }
    activate(index) {
      this.tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].hidden = !active;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
